import React from 'react';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
export const WaterbillIcon = (props) => {
    const { serviceID, value } = props;
    const classes = commonStyle();
    let colorNonSelected = classes.svg_non_selected;
    let colorSelected = classes.svg_selected;
    if (serviceID !== value) {
        colorSelected = classes.svg_non_selected;
    }

    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style={{ enableBackground: 'new 0 0 512 512' }}
        >
            <path
                className={colorSelected}
                d="M222.4,453.3c-1.3,0-2.7-0.2-4.2-0.7c-27.9-8.7-52.8-26.4-70.3-49.8c-18.1-24.3-27.7-53.2-27.7-83.5
	c0-30.1,9.4-58.7,27.1-82.7c2.7-3.7,7-5.9,11.5-5.9c2.2,0,4.3,0.5,6.2,1.4c3.3,1.6,5.9,4.4,7.1,8c1.2,3.5,1,7.3-0.7,10.7
	c-0.3,0.6-0.6,1.2-0.9,1.6c-0.1,0.1-0.1,0.2-0.2,0.3l-0.1,0.2l-0.1,0.2c-14.2,19.2-21.7,42.1-21.7,66.1c0,49,31.5,91.8,78.3,106.4
	c7.4,2.4,11.5,10.4,9.1,17.7C233.9,449.4,228.5,453.3,222.4,453.3z"
            />
            <path
                className={colorNonSelected}
                d="M242,512c-103.5,0-187.6-84.2-187.6-187.6c0-40.3,12.6-78.6,36.4-111L230.3,6.2c2.5-3.8,7-6.2,11.6-6.2
	c4.7,0,9,2.3,11.6,6.2l77.9,115.7L354.2,88c2.5-3.8,7-6.2,11.6-6.2c4.7,0,9,2.3,11.6,6.2l62.4,92.6c11.6,15.7,17.7,34.4,17.7,54.2
	c0,25.5-10.6,49.9-29.3,67.2c0.9,7.2,1.3,14.8,1.3,22.5C429.7,427.8,345.5,512,242,512z M113.5,229.8
	c-20.3,27.5-31.1,60.2-31.1,94.6c0,87.9,71.6,159.5,159.5,159.5s159.5-71.6,159.5-159.5c0-1.8,0-3.5-0.1-5.1
	c-11.1,4.7-23.2,7.1-35.4,7.1c-50.6,0-91.7-41.1-91.7-91.7c0-19.7,6.1-38.5,17.7-54.1l22.6-33.6L241.9,39.2L113.8,229.5l-0.2,0.2
	L113.5,229.8z M314.9,196.6l-0.2,0.3c-8.1,10.9-12.4,24-12.4,37.7c0,35.1,28.5,63.6,63.6,63.6s63.6-28.5,63.6-63.6
	c0-13.8-4.3-26.8-12.4-37.7l-0.2-0.3l-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.3L366,120.8l-24,35.6h-0.1l-26.7,39.7
	c-0.1,0.1-0.1,0.2-0.2,0.3L314.9,196.6z"
            />
            <path
                className={colorNonSelected}
                d="M253,461.2c-1,0-1.9-0.1-2.8-0.3c-5-0.9-9-4.6-10.6-9.6s-0.3-10.4,3.4-14c2.6-2.7,6.1-4.2,9.9-4.2
	c5.8,0,11.1,3.5,13.1,8.7c1.8,4.2,1.3,9.1-1.3,13C262,458.8,257.6,461.2,253,461.2L253,461.2z"
            />
        </svg>
    );
};
